import { Link } from '@mui/material';
import type { MouseEvent } from 'react';

interface VariableColumnHeaderProps {
  title: string;
  /** The variable's own page: followed by a modified click (new tab/window). */
  href: string;
  /** Opens the variable's definition popup; run by a plain click. */
  onOpen: () => void;
}

// A results-grid column header that names an analytical variable. A plain click
// opens the variable's definition in a popup; Cmd/Ctrl/Shift/middle click follow the
// link to the variable's page in a new tab or window. Clicks stop here so they do
// not also sort the column, which is what a click on the rest of the header does.
export const VariableColumnHeader = ({ title, href, onOpen }: VariableColumnHeaderProps) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    onOpen();
  };

  return (
    <Link
      href={href}
      underline="hover"
      color="primary"
      onClick={handleClick}
      // The grid listens for these on the header cell to start a sort or open its menu.
      onDoubleClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      title={title}
      data-testid="analysis-results-variable-column-link"
      sx={{
        display: 'block',
        minWidth: 0,
        font: 'inherit',
        fontWeight: 'inherit',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {title}
    </Link>
  );
};
